import { TFunction } from 'i18next';

export enum STATUS {
  ACTIVE = 1,
  INACTIVE = 0,
}
export enum CustomerAccountType {
  PERSONAL = 1,
  BUSINESS = 2,
}
export enum AuthenticImageType {
  IDENTITY_CARD = 1,
  DRIVER_LICENSE = 2,
}
export enum DISPLAY_NOTIFICATION {
  LANDING_PAGE = 1,
  DASHBOARD = 2,
}
export enum MAX_PRICE {
  MAX_TOTAL_PRICE = 2000000000,
}

export enum STATUS_ORDER {
  REQUEST = 1,
  PAYMENT_PENDING = 2,
  PURCHASING = 3,
  IMPORTED = 4,
  PAYMENT_CONFIRMED = 5,
  PAYMENT_CONFIRMED2 = 51,
  DELIVERING = 6,
  ERROR = 61,
  PICKED_UP = 52,
  PROCESSING = 51,
  COMPLETED = 7,
  DELIVERY_FAILED = 8,
  CANCELED = 9,
}
export enum CountryCode {
  JAPAN = 'JP',
}
export enum OrderTrackingType {
  REQUESTED = 1,
  PROCESSING = 12, // SHIPPING VENDOR
  PICKED_UP = 13, // SHIPPING VENDOR
  PAYMENT_PENDING = 2,
  PURCHASING = 3,
  IMPORTED = 4,
  PAYMENT_CONFIRMED = 5,
  CREATE_TRANSPORT_ORDER = 51, // For Admin
  DELIVERING = 6,
  COMPLETED = 7,
  DELIVERY_FAILED = 8,
  ADDITIONAL_PAYMENT_SENT = 90,
  ADDITIONAL_PAYMENT_CONFIRMED = 91,
  CANCELED = 99,
}
export enum KEY_SIDE_NAV {
  DASHBOARD = '1',
  MY_PROFILE = '2',
  PROFILE_PERSONAL_INFORMATION = '2.1',
  PROFILE_DELIVERY_ADDRESS_BOOK = '2.2',
  PROFILE_EMAIL_ADDRESS = '2.3',
  PROFILE_CHANGE_PASSWORD = '2.4',
  PROFILE_CHANGE_ACCOUNT = '2.5',
  PROFILE_PRIVACY_POLICY = '2.6',
  ORDER = '3',
  SHIPPING = '3.1',
  SHIPPING_2 = '3.1.1',
  SHIPPING_SHIPPING_FROM_HOME = '3.1.2',
  SHOPPING = '3.2',
  CUSTOMS_DUTY = '3.3',
  WAREHOUSE = '4',
  PAYMENT_HISTORY = '5',
  REPORTS = '6',
  PACKAGE = '6',
}
export enum ShoppingType {
  BUY = 1,
  SHIP = 2,
}
export enum IsSortCountryNumber {
  ASC = 0,
  DESC = 1,
}
export enum CARD_TYPE {
  AMERICA_EXPRESS = 'American Express',
  DINERS_CLUB = 'Diners Club',
  DISCOVER = 'Discover',
  JCB = 'JCB',
  MASTER_CARD = 'MasterCard',
  UNION_PAY = 'UnionPay',
  VISA = 'Visa',
}
export enum CustomerUpgradeStatus {
  REQUESTED = 1,
  REJECTED = 2,
  ACCEPTED = 3,
}
export enum STATUS_REMOVE_ACCOUNT {
  ConfirmRemoveAccount = 99,
  Invoice_Group_Postpaid_Pending = 68, //business japan
  Order_Pending = 66, //business nuoc ngoai
  Invoice_Pending = 67, //business nuoc ngoai
}
export enum SEVER_ERROR_CODE {
  TRIAL_EXPIRED = 49,
}
export enum OrderType {
  SHIPPING = 1,
  SHOPPING = 2,
  SHIPPING_FROM_HOME = 3,
}
export enum InvoiceSenderType {
  AUTO = 1,
  ADMIN = 2,
  VENDOR = 3,
}
export enum ACTIVE {
  TRUE = 1,
  FALSE = 0,
}
export enum VendorCode {
  FEDEX = 'FEDEX',
  FEDEX_ECONOMY = 'FEDEX_ECONOMY',
  FEDEX_CONNECT_PLUS = 'FEDEX_CONNECT_PLUS',
  DHL = 'DHL',
  Dmail = 'DMAIL',
}
export enum OrderDocumentStatus {
  DRAFT = 1,
  COMPLETED = 2,
}
export enum LANGUAGE {
  JA = 'ja',
  EN = 'en',
}
export enum CustomerLocationType {
  DOMESTIC = 1,
  FOREIGN = 2,
}
export enum OrderPaymentStatus {
  PENDING = 1,
  CONFIRMED = 2,
  ADDITIONAL = 3,
}
export enum CustomsDutyStatus {
  UNCONFIRMED = 1,
  CONFIRMED = 2,
  PAID = 3,
}
export enum CustomsDutyPayerType {
  CIELO = 1,
  IMPORTER = 2,
}
export enum CustomsDutyAmountFilterStatus {
  UNCONFIRMED = 1,
  CONFIRMED = 2,
}
export enum CustomsDutyPaymentFilterStatus {
  UNPAID = 1,
  PAID = 2,
}
export enum CustomsDutyFilterStatus {
  AMOUNT_CONFIRMED = 1,
  AMOUNT_UNCONFIRMED = 2,
  PAYMENT_PAID = 3,
  PAYMENT_UNPAID = 4,
}
export enum InvoiceStatus {
  CANCELED = 0,
  REFER = 1,
  APPLYING = 2,
  PAID = 3,
}
export enum OrderClassification {
  PAPERS = 1, //giấy tờ, tài liệu
  GOODS = 2, //hàng hóa
}
export enum OptionalServiceCode {
  STORAGE_FEE = 'STORAGE_FEE',
  DOCUMENT = 'DOCUMENT',
  LIMIT_ITEM = 'LIMIT_ITEM',
  INSURANCE = 'INSURANCE',
}
export enum OrderImageCreatorType {
  CUSTOMER = 1,
  ADMIN = 2,
}
export enum KEY_MENU {
  personal_information = 1,
  delivery_address_book = 2,
  email_address_book = 3,
  change_password = 4,
  change_subscription = 5,
  privacy_policy = 6,
  logout = 7,
}

export const getOrderStatusText = (status: number, t: TFunction, isOrderError = false) => {
  let statusText = '--';
  switch (status) {
    case STATUS_ORDER.REQUEST:
      statusText = t('statusOrder.requested');
      break;
    case STATUS_ORDER.PAYMENT_PENDING:
      statusText = t('statusOrder.paymentPending');
      break;
    case STATUS_ORDER.PURCHASING:
      statusText = t('statusOrder.purchasing');
      break;
    case STATUS_ORDER.IMPORTED:
      statusText = t('statusOrder.imported');
      break;
    case STATUS_ORDER.PAYMENT_CONFIRMED:
      statusText = t('statusOrder.paymentConfirmed');
      break;
    case STATUS_ORDER.PAYMENT_CONFIRMED2:
      statusText = t('statusOrder.paymentConfirmed');
      break;
    case STATUS_ORDER.PROCESSING:
      statusText = t('statusOrder.processing');
      break;
    case STATUS_ORDER.PICKED_UP:
      statusText = t('statusOrder.pickedUp');
      break;
    case STATUS_ORDER.DELIVERING:
      statusText = t('statusOrder.deliverying');
      break;
    case STATUS_ORDER.ERROR:
      statusText = t('statusOrder.error');
      break;
    case STATUS_ORDER.COMPLETED:
      statusText = t('statusOrder.completed');
      break;
    case STATUS_ORDER.DELIVERY_FAILED:
      statusText = t('statusOrder.failedDelivery');
      break;
    case STATUS_ORDER.CANCELED:
      statusText = t('statusOrder.canceled');
      break;
  }
  return isOrderError && status !== STATUS_ORDER.ERROR && statusText !== '--'
    ? `${statusText} (${t('statusOrder.error')})`
    : statusText;
};

export const getTrackingStatusText = (status: number, t: TFunction) => {
  switch (status) {
    case OrderTrackingType.REQUESTED:
      return t('statusOrder.requested');
    case OrderTrackingType.PROCESSING:
      return t('statusOrder.processing');
    case OrderTrackingType.PICKED_UP:
      return t('statusOrder.pickedUp');
    case OrderTrackingType.PAYMENT_PENDING:
      return t('statusOrder.paymentPending');
    case OrderTrackingType.PURCHASING:
      return t('statusOrder.purchasing');
    case OrderTrackingType.IMPORTED:
      return t('statusOrder.imported');
    case OrderTrackingType.PAYMENT_CONFIRMED:
      return t('statusOrder.paymentConfirmed');
    case OrderTrackingType.DELIVERING:
      return t('statusOrder.deliverying');
    case OrderTrackingType.COMPLETED:
      return t('statusOrder.completed');
    case OrderTrackingType.DELIVERY_FAILED:
      return t('statusOrder.failedDelivery');
    case OrderTrackingType.CANCELED:
      return t('statusOrder.canceled');
    default:
      return '--';
  }
};
